export interface IListData {
    publisher: string,
    article: string,
    field?: string,
    paragraph?: string,
}

export enum ArticleLocation {
    Body = 0,
    Title = 1,
    Grid = 2,
}

export interface ILocation {
    location: ArticleLocation;
    // The paragraph; with a sentence, numbered as the Words export numbers it (textToWords numberedSentenceExtent).
    index: number;
    sentence?: number;
}
